// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"297":"0ef12566","595":"7977987b","837":"755c6e9d"}[chunkId] + ".chunk.css";
};